/**
 * Moments: milestones for the birth story (one of each per pregnancy).
 * The spot is a point on a front view of the bump, x/y in -1..1 (y up),
 * so it can be drawn on any picture of the bump, 2D or 3D.
 */
export const MOMENT_KINDS = ['first_kick', 'partner_felt', 'last_before_birth'] as const;
export type MomentKind = (typeof MOMENT_KINDS)[number];

export interface Moment {
  kind: MomentKind;
  week: number | null;
  x: number | null;
  y: number | null;
  note: string | null;
  updatedAt: number;
}

export const MOMENT_NOTE_MAX = 300;

export function makeMoment(kind: MomentKind, week: number | null, spot: { x: number; y: number } | null, note: string, now: number): Moment {
  const w = week === null || !Number.isFinite(week) ? null : Math.min(45, Math.max(4, Math.round(week)));
  const clampU = (v: number) => Math.min(1, Math.max(-1, +v.toFixed(3)));
  const n = note.trim().slice(0, MOMENT_NOTE_MAX);
  return { kind, week: w, x: spot ? clampU(spot.x) : null, y: spot ? clampU(spot.y) : null, note: n || null, updatedAt: now };
}
